import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { CloseIcon } from '@beef/ui-kit';
import { getCookie, setCookie } from '@beef/utils';
import { useClassOnScroll } from "../../hooks/useClassOnScroll";
import { ETopBannerType } from "../../types";
import { Metric, headerMetric } from "../../metric";
import { MarqueeText } from "./components/MarqueeText";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var TopBanner = function TopBanner(_ref) {
  var banner = _ref.banner,
    setIsBannerHidden = _ref.setIsBannerHidden,
    cookies = _ref.cookies;
  var url = banner.url,
    text = banner.text,
    background = banner.background,
    imageUrl = banner.imageUrl,
    id = banner.id,
    ttl = banner.ttl,
    domainControl = banner.domainControl,
    type = banner.type;
  var _useState = useState((cookies === null || cookies === void 0 ? void 0 : cookies.hideBanner["hideBanner".concat(id)]) === 'hide'),
    _useState2 = _slicedToArray(_useState, 2),
    isShowBanner = _useState2[0],
    setIsShowBanner = _useState2[1];
  var bannerRef = useRef(null);
  useClassOnScroll(bannerRef, cx({
    'banner--hidden': type === ETopBannerType.promo
  }));

  // Используем useEffect только для отправки метрики и уведомления родителя о текущем состоянии баннера.
  useEffect(function () {
    if (!getCookie("hideBanner".concat(id))) {
      setIsShowBanner(true);
      setIsBannerHidden(false);
      headerMetric.handleTopBannerEvent(JSON.stringify({
        bannerTitle: text,
        bannerUrl: url,
        bannerId: id
      }), 'view');
    } else {
      setIsShowBanner(false);
      setIsBannerHidden(true);
    }
  }, [isShowBanner, id, setIsBannerHidden, text, url]);
  var handleClick = function handleClick() {
    setCookie({
      name: "hideBanner".concat(id),
      value: 'hide',
      domain: domainControl,
      ttl: ttl
    });
    setIsShowBanner(false);
    setIsBannerHidden(true);
  };
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": !isShowBanner,
    className: cx('banner-wrap', {
      hidden: !isShowBanner
    }),
    ref: type === ETopBannerType.promo ? bannerRef : undefined,
    style: {
      backgroundColor: background
    },
    "data-t-id": "components-TopBanner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('banner')
  }, type === ETopBannerType.promo ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      bannerTitle: text,
      bannerUrl: url,
      bannerId: id
    }),
    events: {
      headerMetric: ['handleTopBannerClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement("a", {
    className: cx('link'),
    href: url,
    onClick: handleClick,
    tabIndex: isShowBanner ? 0 : -1,
    "data-t-id": "components-TopBanner"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('image'),
    src: imageUrl
  }), text && /*#__PURE__*/React.createElement(Text, {
    lineHeight: 24,
    size: 16
  }, text))), /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: JSON.stringify({
      bannerTitle: text,
      bannerUrl: url
    }),
    events: {
      headerMetric: ['handleTopBannerClose']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0421\u043A\u0440\u044B\u0442\u044C \u0431\u0430\u043D\u043D\u0435\u0440",
    className: cx('close-button'),
    onClick: handleClick,
    tabIndex: isShowBanner ? 0 : -1,
    type: "button",
    "data-t-id": "components-TopBanner"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    size: 20
  })))) : /*#__PURE__*/React.createElement(MarqueeText, {
    text: text,
    url: url
  })));
};